import { trackClientEvent } from '../../../../../trackClientEvent';
import { timingPairStringify, } from '@faire/web/common/timings/TimingMarker';
export const eventKey = 'retailer_marketing-builder_landing_page_status-action_unknown';
/**
 * measure builder landing page success rate and performance
 */
export function trackRetailerMarketingBuilderLandingPageStatus(page_namestring, status_string2, timingParameterToken, path_name3 = '') {
    var _a;
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        parameters: {
            page_namestring,
            status_string2,
            timingParameterToken: (_a = timingPairStringify(timingParameterToken)) !== null && _a !== void 0 ? _a : '',
            path_name3,
        },
    });
}
